module.exports = __webpack_public_path__ + "static/media/roboto-v20-latin-700.2735a3a6.woff2";